import React from 'react'
import { Anchor } from '../../layout/Anchor'
import Input from '../../layout/Input'

type PrivacyPolicyCheckboxProps = {
  value: boolean
  onChange: (e: string) => void
}

export const PrivacyPolicyCheckbox: React.FC<PrivacyPolicyCheckboxProps> = ({ value, onChange }) => {
  return (
    <Input
      name="privacyPolicy"
      label={
        <>
          Ich stimme dem <Anchor href="https://terminslot.de/Datenschutz">Datenschutzrichtlinie</Anchor> zu.
        </>
      }
      value={value}
      type="checkbox"
      onChange={onChange}
    />
  )
}
